import { SelectSearchField } from './SelectSearchField'
import { withSelectSearchField } from './withSelectSearchField'

const ConnectedSelectSearchField = withSelectSearchField(SelectSearchField)
export { ConnectedSelectSearchField as SelectSearchField }
